export default "__VITE_ASSET__DQa$gdKM__ 100w";